import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import endpoint from "../../../config/endpoints";
import { noInternetMsg, savemsg, saveWarningMsg, serverMsg, updateData, updateMsg } from "../../../config/messageconstant";
import { holidayJson } from "../../../DynamicFormsJson/MastersJSON/holiday";
import { apiGet, apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import dayjs from "dayjs";

class HolidayMasterForm extends React.Component {
    constructor(props) {
        super(props);
    }

    getDataById = async (id) => {
        const { showLoador } = this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });
            const response = await apiGet({
                url: endpoint.holiday + "/" + id,
            }).then(({ data, success }) => {
                if (success) {
                    if (!data.error) {
                        let rowData = data.data;

                        const day = String(rowData.day).padStart(2, '0');
                        const month = String(rowData.month).padStart(2, '0');
                        const year = dayjs().year();
                        const dateString = `${day}-${month}-${year}`;

                        let dataToSet = {
                            ...rowData,
                            date: dateString,
                        };
                        return { data: dataToSet, success };
                    }
                    return { data: {}, success: false };
                }

                return { data: {}, success: false };
            });
            showLoador({ loador: false });
            return response;
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    submitHandler = (data) => {
        const { showLoador, showNotification } = this.props;
        const [day, month] = data.date.split("-");
        const dataToSave = {
            id: this.props.params.id,
            name: data?.name,
            day: day,
            month: month,
        }
        if (navigator.onLine) {

            swal({
                title: "Are you sure?",
                text: this.props.params.id ? updateData : saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiPost({
                        url: endpoint.holiday,
                        postBody: dataToSave,
                    }).then(({ data, success }) => {
                        if (!success) {
                            showNotification({
                                msg: serverMsg,
                                severity: "error",
                            });
                        } else {
                            showNotification({
                                msg: this.props.params.id ? updateMsg : savemsg,
                            });
                            this.props.navigate(-1);
                        }
                    });
                    showLoador({ loador: false });
                }
            })
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }


    render() {
        return (
            <>

                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutSave
                        showBackToList={true}
                        getByIdApi={true}
                        callApi={true}
                        screenTitle={holidayJson.screenTitle}
                        fieldMeta={holidayJson.fieldMeta}
                        showCancel={holidayJson.showCancel}
                        showSaveNextBtn={true}
                        saveBtnText={"Save"}
                        showSaveBtnMain={false}
                        showSaveBtn={true}
                        onSave={this.submitHandler}
                        getDataById={this.getDataById}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(HolidayMasterForm);
